App.controller('ZochReportHealthPzuwListCtrl', ['$scope', '$sce', '$state', 'Config', 'zochaReportService', '$timeout', '$stateParams', 'Blob', 'FileSaver', '$rootScope', 'popUpService', 'branchService', '$filter', '$interval', function ($scope, $sce, $state, Config, zochaReportService, $timeout, $stateParams, Blob, FileSaver, $rootScope, popUpService, branchService, $filter, $interval) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_report';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Lista raportów - TUW PZUW';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.dashboard';
    $scope.$emit('link', $scope.link);

    let page = 0;
    let generateTimeout;
    let generateReportInterval;
    $scope.current = page;
    $scope.pageSize = 10;

    let userObject = angular.fromJson(window.sessionStorage.getItem('userObject'));
    $scope.userBranch = userObject.branch;

    loadReports(page);
    loadBranch();

    function loadBranch() {
        $rootScope.selectedBranch = null;
        $scope.branches = [];
        branchService.getZochaAllowedBranchesForReports().then(function (data) {
            $scope.branches = data.data.data;
            if ($filter('prepareRights')('ZOCHA_ALL_REPORTS')) {
                $scope.branches.unshift({id: -1, name: 'Wszystkie'});
            }
            $rootScope.selectedBranch = $scope.branches[0];
        });
    }

    function createFilterForItem(query) {
        let lowercaseQuery = query.toLowerCase();
        return function filterFn(items) {
            return (items.name.toLowerCase().indexOf(lowercaseQuery) !== -1);
        };
    }

    function loadReports(page) {
        let criteria = {
            pageNumber: page,
            pageSize: $scope.pageSize
        };

        zochaReportService.getEmployerHealthInsurancePzuwReports(criteria)
            .then(function (data) {
                if (data.status === 200) {
                    $scope.reports = data.data.data;
                    $scope.numberOfPages = data.data.pages;

                }
            });
    }

    $scope.querySearchBranch = function (query) {
        return query ? $scope.branches.filter(createFilterForItem(query)) : $scope.branches;
    };

    $scope.pageChanged = function (page) {
        loadReports(page);
        $scope.current = page;

    };

    $scope.downloadReport = function (ev, value) {

        let el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }

        zochaReportService.downloadEmployerHealthInsurancePzuwReport(value.id).then(function (data) {
            if (data.status === 200) {
                let blob = new Blob([data.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                FileSaver.saveAs(blob, $filter('getFileNameFromContentDisposition')(data.headers('Content-Disposition')));
            }

            $timeout(function () {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });

    };

    $scope.generate = function (ev) {
        let el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }

        if (!$scope.selectedBranch) {
            popUpService.showPopUp({head: 'Brak oddziału', content: 'Nie posiadasz przypisanego oddziału'});
            return;
        }

        if (generateTimeout) {
            $timeout.cancel(generateTimeout);
        }

        let branchId = null;
        if ($scope.selectedBranch.id > 0) {
            branchId = $scope.selectedBranch.id;
        }
        let reportParams = {
            branchId: branchId,
            companyId: Config.COMPANY_ID,
        };

        zochaReportService.generateEmployerHealthInsurancePzuwReport(reportParams)
            .then(function (data) {
                if (data.status === 200) {
                    $state.reload();
                }

                generateTimeout = $timeout(function () {
                    $(ev.currentTarget).removeClass('disabled');
                    $state.reload();
                }, 3000);
            });
    };

    function expandMenuAfterReload() {
        let target = $('ul.menu.menu_5');
        if (!target) {
            return;
        }
        let h = target[0].scrollHeight;

        $(target).addClass('open');
        $('.sidebar').addClass('opened');
        $(target).velocity("stop", true).velocity({height: h});
    }

    $timeout(function () {
        expandMenuAfterReload();
    }, 500);

    generateReportInterval = $interval(function () {
        loadReports(page);
    }, 5000);

    $scope.$on('$destroy', function () {
        if (angular.isDefined(generateTimeout)) {
            $timeout.cancel(generateTimeout);
            generateTimeout = undefined;
        }
        if (angular.isDefined(generateReportInterval)) {
            $interval.cancel(generateReportInterval);
            generateReportInterval = undefined;
        }
    });
}]);
